import React from 'react'
import {Grid, Typography, Card} from '@mui/material'
import TopUpBank from '../components/main/topUp/bank/TopUpBank'
import TopUpBankOptions from '../components/main/topUp/bank/TopUpBankOptions'
import TopUpOptions from '../components/main/topUp/TopUpOptions'
import colors from '../components/colors'
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux';
import {selectTopUpData, resetTopUpMessage} from '../features/userInfo/topUpSlice'
import {selectGlobalDataState} from '../features/global/globalDataSlice'
import {selectUserInfo} from '../features/userInfo/userInfoSlice'
import Lottie from "lottie-react";
import FallingCoins from '../icons/lottieAnimations/coins.json'
import {setGeneralMessage} from '../features/global/globalDataSlice'
import BankTransfer from '../components/main/topUp/bankTransfer/BankTransfer'
import { sendGeneralRequest } from '../features/generalRequest'
import { makeStyles } from '@mui/styles';
import CardOnFile from '../components/main/topUp/cardOnFile/CardOnFile'
import { texts } from '../components/general/texts'
import TopUpLocations from '../components/main/topUp/topUpLocations/TopUpLocations'

export const TopUp = () => {
    const dispatch = useDispatch()
    const topUpData = useSelector(selectTopUpData)
    const userInfo = useSelector(selectUserInfo)
    const globalDataSliceState = useSelector(selectGlobalDataState)

    React.useEffect(()=>{
        if(topUpData.banks.length === 0)
        {
            dispatch(sendGeneralRequest({request: { token: globalDataSliceState.token }, baseUrlKey:'services', endpoint:'GetAccountBankInfo'}))
        }
        topUpData.message !== '' && dispatch(setGeneralMessage({type: 'success', message: topUpData.message}))
        return () => {
            dispatch(resetTopUpMessage())
        }
    },[topUpData.message, topUpData.banks])

    const useStyles = makeStyles({
        card:{
            borderRadius:'20px',
            height:'100%',
            width:'25%',
            boxShadow:'0 0 15px 5px #E5E7EA',
            '@media (max-width: 1440px)' : {width:'40%'},
            '@media (max-width: 899px)' : {width:'60%'},
            '@media (max-width: 500px)' : {width:'90%'}
        },
        header:{
            color:colors.darkBlue,
            fontFamily:'GerberaBold',
            fontSize:'1.5rem'
        },
        balance:{
            fontSize:'2rem',
            fontFamily:'GerberaLight',
            color:colors.orange
        }
    })

    const classes = useStyles()

  return (
      
    <Grid container>
        <Grid container item md={12} xs={12} justifyContent={'center'} pb={4} pt={'2%'}>        
            <Card  md={12} xs={12} className={classes.card}>
                <Grid container mt={1} mb={1} >
                    <Grid container item md={8} xs={8} justifyContent="center" alignContent={'center'} rowSpacing={2} ml={2} >
                        <Grid container item md={12} xs={12} >
                            <Typography className={classes.header}>{texts["title-balance"]}</Typography>
                        </Grid>
                        <Grid container item md={12} xs={12} >
                            <Typography className={classes.balance} >{userInfo.balance} {texts["currency"]}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container item md={3} xs={3} justifyContent="center" alignContent={'center'}>
                        <Lottie animationData={FallingCoins} loop={false} autoplay={true} width={50} height={50} />
                    </Grid>
                </Grid>
            </Card>
        </Grid>
        <Grid md={12} xs={12} container item justifyContent='center'>
            
            <Routes>
                <Route index element={<TopUpOptions/>}/>
                <Route path={"topUpBankOptions"} element={<TopUpBankOptions bankData={topUpData.banks}/>}/>
                <Route path={"topUpBankOptions/topUpBank"} element={<TopUpBank bankData={topUpData.banks}/>}/> 
                {/* <Route path={"topUpCard"} element={<TopUpCard/>}/> */}
                <Route path={"topUpCard"} element={<CardOnFile/>}/>
                <Route path={"bankTransfer"} element={<BankTransfer/>}/>
                <Route path={"cardOnFile"} element={<CardOnFile/>}/>   
                <Route path={"topUpLocations"} element={<TopUpLocations />}/>                                                                  
            </Routes>
        
        </Grid>
    </Grid>
  )
}
export default TopUp





